import { render, staticRenderFns } from "./Provisioning.vue?vue&type=template&id=0ba82c6b&scoped=true&"
import script from "./Provisioning.vue?vue&type=script&lang=js&"
export * from "./Provisioning.vue?vue&type=script&lang=js&"
import style0 from "./Provisioning.vue?vue&type=style&index=0&id=0ba82c6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba82c6b",
  null
  
)

export default component.exports